//Please add the language resource
const reshipCornOrder = {
  plantName:'基地',
  planNo:"计划单",
  schNo:'车辆调度单',
  orderNo:'倒运单',
  vehicleNo:'车牌号',
  driverTel: '司机电话',
  currentNodeName: '订单运作状态',
  businessTypeName: '业务类型',
  goodsCategoryName: '货物类别',
  lotNo: '计划批次号',
  originStorageName: '出货库位',
  loadingTypeName: '装车工具',
  destStorageName: '收货库位',
  schSeq: '当日倒运顺序',
  reshipDate: '倒运日期',
  planWeight: '计划倒运重量(吨)',
  netWeight: '实际倒运量(吨)',
  msg:{
  }
};
export default reshipCornOrder



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornOrder/lang/reshipCornOrder.en.js